import { Attachment } from 'interfaces';

export enum PreviewMessageType {
  ERROR,
  SUCCESS,
}

export interface PreviewMessage {
  type: PreviewMessageType;
  text?: string;
}

export interface TelegramPostPreviewProps {
  avatarUrl?: string;
  channelName?: string;
  attachments?: Attachment[];
  title: string;
  message: string;
  previewMessages?: PreviewMessage[];
}
